import InteresUpdate from './InteresUpdate'
export {InteresUpdate}
export default InteresUpdate
